import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  DateRange,
  extractDateRange,
  extractDefaultStoreId,
  extractNumber,
  extractNumberArr,
  HxProductService,
  HxReportService,
  HxStoreService,
  HxUiLabelPipe,
  isoDate,
  ProductInfoType,
  StoreBasicModel,
  toRouterQueryParams
} from 'hx-services';
import { ActivatedRoute, Router } from '@angular/router';
import { eachDayOfInterval, parseISO } from 'date-fns';
import { Subscription } from 'rxjs';
import { HxDateRangeSelectComponent, HxLoaderComponent, HxProductCategorySelectComponent, HxProductInfoSelectComponent, HxStoreSelectComponent } from 'hx-component';
import { FormsModule } from '@angular/forms';
import { DatePipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-storage-report.m-grid__item.m-grid__item--fluid.m-wrapper',
    templateUrl: './storage-report.component.html',
    styleUrls: ['./storage-report.component.css'],
    imports: [HxStoreSelectComponent, FormsModule, HxDateRangeSelectComponent, HxProductInfoSelectComponent, HxProductCategorySelectComponent, NgIf, NgFor, NgClass, NgbTooltip, HxLoaderComponent, DatePipe, TranslocoPipe, HxUiLabelPipe]
})
export class StorageReportComponent implements OnInit, OnDestroy {
  list = [];
  isLoading = {
    list: true,
    products: false,
  };
  params: {
    storeId?: number,
    date?: DateRange,
    productInfoIds?: number[],
    categoryIds?: number[],
  } = {};
  pagination = {
    allItemCount: 0
  };
  formatData: string[] = [];
  map = new Map();
  brandId?: number;
  selectedPITypes: ProductInfoType[] = [ProductInfoType.PRODUCT, ProductInfoType.PROPERTY];
  private sub: Subscription;

  constructor(
    private reportService: HxReportService,
    private productService: HxProductService,
    private storeService: HxStoreService,
    private aRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.brandId = localStorage.getItem('defaultBrandId') ? Number(localStorage.getItem('defaultBrandId')) : undefined;
    this.sub = this.aRoute.queryParamMap.subscribe(paramMap => {
      this.params.date = extractDateRange('date', paramMap);
      this.params.storeId = extractNumber('storeId', paramMap) ?? extractDefaultStoreId();
      this.params.productInfoIds = extractNumberArr('productInfoIds', paramMap);
      this.params.categoryIds = extractNumberArr('categoryIds', paramMap);
      if (this.params.storeId) {
        this.storeService.getStoreById(this.params.storeId).then(store => {
          this.brandId = store.brandId;
        });
        this.loadList();
      }
      if (this.params.date) {
        const dateInRange = eachDayOfInterval({start: parseISO(this.params.date.from), end: parseISO(this.params.date.to)});
        this.formatData = dateInRange.map(e => isoDate(e));
      }
    });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  private navigate() {
    this.router.navigate(['./'], {
      queryParams: toRouterQueryParams(this.params),
      relativeTo: this.aRoute
    });
  }

  onStoreChanged(store?: StoreBasicModel | StoreBasicModel[]) {
    if (Array.isArray(store)) {
      return;
    }
    if (!store || this.brandId !== store?.brandId) {
      this.params.categoryIds = [];
      this.params.productInfoIds = [];
    }
    this.brandId = store?.brandId;
    this.applyFilters();
  }

  applyFilters() {
    this.navigate();
  }

  resetFilter() {
    this.params = {};
    this.navigate();
  }

  private loadList() {
    this.isLoading.list = true;
    this.list = [];
    this.reportService.getStorageReport(this.params).subscribe(result => {
      this.list = result || [];
      this.list.map(r => {
        r.statInDateRange.forEach(t => {
          this.map.set(r.productInfoId + '.' + t.date, t);
        });
      });
      this.isLoading.list = false;
    }, err => this.isLoading.list = false);
  }
}
